import { css, SerializedStyles } from '@emotion/react';

import { ACCENT, DARK_BG } from '../scanVideoMediaStyles';

/** Match `FocusedPhotoStrip` tile width — list and strip thumbs stay aligned. */
export const FOCUSED_VIDEO_LIST_THUMB_WIDTH_PX = 170;

export type VideoListThumbnailStyles = {
  container: SerializedStyles;
  video: SerializedStyles;
  fallback: SerializedStyles;
};

/** Media-strip video tile thumbnail — shared with FocusedStripVideoTile. */
export const DEFAULT_VIDEO_LIST_THUMBNAIL_STYLES: VideoListThumbnailStyles = {
  container: css`
    label: VIDEO_LIST_THUMB;
    width: ${FOCUSED_VIDEO_LIST_THUMB_WIDTH_PX}px;
    aspect-ratio: 4 / 3;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${DARK_BG};
    color: ${ACCENT};
    position: relative;
    overflow: hidden;
    padding: 0;
  `,
  video: css`
    label: VIDEO_LIST_THUMB_VIDEO;
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    pointer-events: none;
  `,
  fallback: css`
    label: VIDEO_LIST_THUMB_FALLBACK;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
};
